import { DefaultTheme } from 'styled-components'

import { ProgressBarStyleType } from '~/components/ProgressBar/ProgressBar.types'
import ColorPalette from '../colorPalette'
import defaultTheme from './default'

const {
  colors,
  button,
  navigationSlider,
  label,
  explicitSelectionButton,
  input,
  spinner,
  datepicker,
  breadcrumb,
  areaLineColorSchemes,
  areaLine,
  starRating,
  popup,
  priorityTag,
  avatar,
  evaluation,
  progressBar,
  oneTimePassword,
  dotNavigation,
  saf,
  alertBanner,
  divider,
  mouseOver
} = defaultTheme

const grid = {
  columnWidth: 128,
  gutter: 24,
  margin: 48,
  additionalMargin: 12
}

const informationCard = {}

const card = {}

const feedbackCard = {}

const darkProgressBar: ProgressBarStyleType = {
  ...progressBar,
  backgroundColor: ColorPalette.colorSupportDarkGrey
}

const theme: DefaultTheme = {
  colors,
  grid,
  button,
  navigationSlider,
  label,
  explicitSelectionButton,
  informationCard,
  fonts: {
    barlow: ''
  },
  input,
  spinner,
  datepicker,
  card,
  feedbackCard,
  breadcrumb,
  areaLine,
  areaLineColorSchemes,
  starRating,
  popup,
  priorityTag,
  avatar,
  evaluation,
  progressBar: darkProgressBar,
  oneTimePassword,
  dotNavigation,
  saf,
  alertBanner,
  divider,
  mouseOver
}

export type ThemeProps = { theme?: DefaultTheme }

export default theme
